import { render, staticRenderFns } from "./AdminNavigation.vue?vue&type=template&id=9f3578a4&"
import script from "./AdminNavigation.vue?vue&type=script&lang=js&"
export * from "./AdminNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QIcon,QSeparator,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QItem,QItemSection,QIcon,QSeparator})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
